if (process.env.NODE_ENV === "production") {
  console.log = () => { };
  console.debug = () => { };
  console.warn = () => { };
}

import React, { createContext } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
  // useSearchParams 
} from "react-router-dom";

import axios from "axios";
import Home from "./Home";
import Content from "./Content";
import Admin from "./Admin";
import Login from "./Login";
import TopNav from "./TopNav";
import TopMenu from "./TopMenu";
import Onboarding from "./Onboarding";

import ProtectedRoute from "./ProtectedRoute";

axios.defaults.withCredentials = true;

export const PopupContext = createContext();

// function AboutUs() {
//   return (
//     // was: <div className="pane pane-center">
//     <div className="pane pane-center dark_pane">
//       <div className="left_right_container">
//         <div className="left">

//           {/* was: <div className="text_pane dark_pane"> */}
//           <div className="text_pane">
//             <h2>About us</h2>
//             <p>
//               We are, apart from our role of researchers in the department of cardiology
//               of University Medical Center Groningen, a team of passionate cyclists, runners,
//               and hikers, united by our commitment to participate in a challenging 
//               action in 2026 to raise funds for the Hartekind actie 2026.
//             </p>
//             <p>
//               We want to challenge you - our colleagues, friends, and family - 
//               to join us in this action, either by participating 
//               in the action itself, or by supporting us with donations. We are all volunteers, and
//               together we will make a significant contribution to the Hartekind actie 2026, which
//               is dedicated to promoting cardiovascular health and wellness of children who were
//               born with congenital heart defects.
//             </p>
//             <hr />
//             <h2>Important information</h2>
//             <ul>
//               <li><a href="/content/terms-and-conditions">Terms &amp; conditions</a></li>
//               <li><a href="/content/privacy-policy">Privacy policy</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="right">
//           <picture>
//             <source srcset="media/glove-web-small.png" media="(max-width: 768px)" />
//             <source srcset="media/glove-web.png" />

//             <img src="media/glove-web.png" alt="MFK Venom glove" />
//           </picture>
//         </div>
//       </div>
//     </div>
//   );
// }

// function Contact(cart) {
//   const [formState, setFormState] = useState('to-be-sent');
//   const [notifyEmail, setNotifyEmail] = useState('');
//   const [message, setMessage] = useState('');
//   const [companyInfo, setCompanyInfo] = useState(null);

//   useEffect(() => {
//     async function fetchCompanyInfo() {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/company_info`);
//         setCompanyInfo(res.data);
//       } catch (err) {
//         console.error("Error fetching company info:", err);
//       }
//     }
//     fetchCompanyInfo();
//   }, []);

//   const handleNotifySubmit = async (e) => {
//     e.preventDefault();

//     if (!notifyEmail || !message) return;

//     const csrfResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
//       credentials: "include" // crucial for cookies
//     });
//     const csrfData = await csrfResponse.json();

//     console.log("Token: " + csrfData.csrfToken);
//     const csrfToken = csrfData.csrfToken;

//     try {
//       const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
//         method: 'POST',
//         headers: { "Content-Type": "application/json", "CSRF-Token": csrfToken },
//         credentials: "include",
//         body: JSON.stringify({
//           email: notifyEmail,
//           message: message
//         })
//       });

//       if (!res.ok) throw new Error('API error');

//       setNotifyEmail('');
//       setFormState('sent');
//     } catch (err) {
//       console.error('Notification request failed:', err);
//       // Optionally show error message
//     }
//   };

//   return (
//     <div className="pane pane-center dark_pane">
//       <div className="left_right_container">
//         <div className="left">
//           <h2>Contact us</h2>
//           {(formState == 'to-be-sent') && (
//             <>
//               <p>
//                 Please enter your message below. We will respond as soon as possible.
//               </p>
//               <form onSubmit={handleNotifySubmit}>
//                 <div className="form-group">
//                   <input
//                     type="email"
//                     required
//                     placeholder="Enter your email"
//                     value={notifyEmail}
//                     onChange={e => setNotifyEmail(e.target.value)}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <textarea
//                     required
//                     placeholder="Enter your message here..."
//                     value={message}
//                     onChange={e => setMessage(e.target.value)}
//                     aria-multiline="true" />
//                 </div>
//                 <div className="form-group">
//                   <button type="submit">Send</button>
//                 </div>
//               </form>
//             </>

//           )}
//           {(formState == 'sent') && (
//             <>
//               <p>
//                 Thanks for contacting us! We will respond as soon as possible.
//               </p>
//             </>
//           )}
//         </div>
//         {companyInfo && (
//           <div className="right">
//             <h2>Headquarters</h2>
//             <label>Address:</label><span>
//               {companyInfo.name}<br />
//               {companyInfo.address.split('\n').map((line, i) => (
//                 <span key={i}>{line}<br /></span>
//               ))}
//             </span><br />
//             <label>General:</label><span>
//               <a href={`mailto:${companyInfo.infoMailAddress}`}>{companyInfo.infoMailAddress}</a><br />
//             </span>
//             <label>Support:</label><span>
//               <a href={`mailto:${companyInfo.supportMailAddress}`}>{companyInfo.supportMailAddress}</a><br />
//             </span>

//           </div>)}
//       </div>
//     </div>
//   );
// }




// export default function App() {




//   const customAlert = (message) => {
//     setPopupState({ type: "alert", message });
//     setTimeout(() => setPopupState(null), 3000);
//   };
//   OrderConfirmation
//   const permanentAlert = (message) => {
//     setPopupState({ type: "permanentAlert", message });
//   };

//   return (
//     <PopupContext.Provider value={customAlert}>
//       <Router>
//         <CartLink cart={cart} />
//         <TopNav cart={cart} />
//         <Routes>
//           <Route path="/" element={<Home cart={cart} />} />
//           {/* <Route path="/about-us" element={<AboutUs cart={cart} />} />
//           <Route path="/contact" element={<Contact cart={cart} />} /> */}
//           <Route path="/routes" element={<StravaHartekindRoutes  />} />
//           {/* customAlert={customAlert} popupState={popupState} setPopupState={setPopupState} */}
//           {/* <Route path="/content/:pageKey" element={<Content cart={cart} />} /> */}
//           {/* catch-all → /content/404 */}
//           {/* <Route path="*" element={<Content404 cart={cart} />} />    */}
//         </Routes>

//         {(popupState?.type === "alert") && (
//           <div className="product-popup">
//             <p>{popupState.message}</p>
//             <div className="popup-buttons">
//               <button onClick={() => setPopupState(null)}>Ok</button>
//             </div>
//           </div>
//         )}
//         {(popupState?.type === "permanentAlert") && (
//           <div className="popup-bg">
//             <div className="product-popup">
//               <p>{popupState.message}</p>
//             </div>
//           </div>
//         )}
//       </Router>
//     </PopupContext.Provider>
//   );
// }

// export default App;

function Layout({ children }) {
  return (
    <div>
      <TopMenu />
      <div className="content">
        {children}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Layout>
        <TopNav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/content/:pageKey" element={<Content />} />
          <Route path="/onboarding/:id" element={<Onboarding />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Layout>
    </Router>
  );
}